import { defineStore } from 'pinia';
import { useApi } from '@/composables/useApi';
import { ref, watchEffect } from 'vue';

export const useGlossaryStore = defineStore('glossary', () => {
	const keywords = ref([]);
	const loadProgress = ref(0);
	const fetchingKeywords = ref(false);

	function getKeywordDetails(keyword) {
		return keywords.value?.find?.(({ path }) => path === keyword) ?? false;
	}

	async function getKeywordList() {
		try {
			fetchingKeywords.value = true;
			loadProgress.value = 0;
			const fetcher = useApi('api/glossary/');
			watchEffect(() => {
				loadProgress.value = fetcher.progress;
			});
			const { data } = await fetcher.get().json();

			keywords.value = data.value;
			fetchingKeywords.value = false;
			return Promise.resolve(data);
		} catch (error) {
			fetchingKeywords.value = false;
			return Promise.reject(error);
		}
	}
	async function ensureKeywords() {
		const noKeywords = !(keywords.value?.length > 0);
		if (noKeywords && !fetchingKeywords.value) {
			await getKeywordList();
		}
	}
	async function saveKeyword({ json }) {
		await useApi(`api/glossary/`, {
			message: 'Saving that keyword failed.',
		}).post(json);
		await getKeywordList();
	}
	async function updateKeyword({ json, id }) {
		await useApi(`api/glossary/${id}/`, {
			message: 'Saving that keyword failed.',
		}).put(json);
		await getKeywordList();
	}
	async function deleteKeyword({ id }) {
		await useApi(`api/glossary/${id}/`).delete();
		await getKeywordList();
	}

	return {
		keywords,
		loadProgress,
		fetchingKeywords,

		ensureKeywords,
		updateKeyword,
		deleteKeyword,
		saveKeyword,

		getKeywordDetails,
		getKeywordList,
	};
});
